export function LoadingState() {
  return (
    <div className="space-y-4">
      {/* Summary skeleton */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="card p-5 animate-pulse">
            <div className="flex justify-between mb-4">
              <div className="h-3 bg-brand-beige rounded w-20" />
              <div className="w-8 h-8 bg-brand-beige rounded-xl" />
            </div>
            <div className="h-8 bg-brand-beige rounded w-14" />
          </div>
        ))}
      </div>

      {/* Table skeleton */}
      <div className="card overflow-hidden animate-pulse">
        <div className="px-6 py-4 border-b border-brand-beige">
          <div className="h-3 bg-brand-beige rounded w-24" />
        </div>
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="flex items-center gap-4 px-6 py-4 border-b border-brand-beige last:border-0"
          >
            <div className="h-4 bg-brand-beige rounded flex-1" />
            <div className="h-4 bg-brand-beige rounded w-8" />
            <div className="h-4 bg-brand-beige rounded w-8" />
            <div className="h-4 bg-brand-beige rounded w-8" />
            <div className="h-6 bg-brand-beige rounded-full w-16" />
            <div className="h-6 bg-brand-beige rounded-full w-20" />
          </div>
        ))}
      </div>
    </div>
  )
}
